'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Common;
(function (Common) {
    var MyCommon = /** @class */ (function () {
        function MyCommon() {
            // スクロールしてヘッダーの内容が変わるまでの距離
            this.changeHeaderParam = 300;
            // PCではないサイズの幅
            this.notpcWidth = 1199;
            var self = this;
            self.createMarginHeader();
            self.moveAnchorPosition();
            window.addEventListener('resize', function () {
                self.createMarginHeader();
            });
            window.addEventListener('scroll', function () {
                if ($(window).scrollTop() >= self.changeHeaderParam) {
                    $('.bulletHeaderContent').addClass('scroll');
                }
                else {
                    $('.bulletHeaderContent').removeClass('scroll');
                }
            });
            $('.trigSwitchMenu').on('click', function () {
                var openFlag = Number($('.paramSwitchMenu').attr('data-open'));
                if (openFlag == 0) {
                    $('.bulletSwitchMenu').fadeIn('slow', function () {
                        $('.paramSwitchMenu').attr('data-open', 1);
                    });
                }
                else {
                    $('.bulletSwitchMenu').fadeOut('slow', function () {
                        $('.paramSwitchMenu').attr('data-open', 0);
                    });
                }
            });
            // ページ内リンク スムーススクロール
            $('a').click(function (e) {
                self.el = $(this);
                self.href = $(this).attr("href");
                if (self.href.match(/^\#/)) {
                    if (self.href != "#") {
                        self.target = $(self.href == "#" || self.href == "" ? 'html' : self.href);
                        self.targetPosition = self.target.offset().top;
                        var windowWidth = $(window).outerWidth();
                        var headerHeight = 0;
                        if (windowWidth > self.notpcWidth) {
                            headerHeight = Number($('.paramHeaderContent').outerHeight());
                        }
                        self.targetPosition = self.targetPosition - headerHeight;
                        // animation OFF でなければスムーススクロール
                        if ($(this).attr("data-no-anime") == "1") {
                            self.scrollSpeed = 0;
                            $("html, body").animate({ scrollTop: self.targetPosition }, self.scrollSpeed, "linear");
                        }
                        else {
                            self.scrollSpeed = 1000;
                            $("html, body").animate({ scrollTop: self.targetPosition }, self.scrollSpeed, "swing");
                        }
                    }
                    return false;
                }
            });
        }
        MyCommon.prototype.getHeaderHeight = function () {
            return Number($('.paramHeaderContent').outerHeight());
        };
        ;
        MyCommon.prototype.getWindowWidth = function () {
            return Number(($(window).outerWidth()));
        };
        MyCommon.prototype.createMarginHeader = function () {
            var headerHeight = this.getHeaderHeight();
            var windowWidth = this.getWindowWidth();
            if (windowWidth > this.notpcWidth) {
                $('.bulletMainContents').css('padding-top', headerHeight);
            }
            else {
                $('.bulletMainContents').css('padding-top', 0);
            }
        };
        MyCommon.prototype.moveAnchorPosition = function () {
            var urlHash = location.hash;
            if (urlHash) {
                var headerHeight = this.getHeaderHeight();
                var windowWidth = this.getWindowWidth();
                if (windowWidth > this.notpcWidth) {
                    if ($(urlHash).length > 0) {
                        var moveAnchorPosition = $(urlHash).offset().top - headerHeight - 50;
                        $("html, body").animate({ scrollTop: moveAnchorPosition }, 0, "swing");
                    }
                }
            }
        };
        return MyCommon;
    }());
    Common.MyCommon = MyCommon;
})(Common || (Common = {}));
exports.default = Common;
